import React from 'react'
import { useRouter } from 'next/router'
import shallow from 'zustand/shallow'

import { historyUtils } from '@wartek-id/toolbox-helper'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'

import FaseSheet from '../components/SheetSelectFase'
import MapelSheet from '../components/SheetSelectMapel'
import SearchSection from '../components/SearchSection'
import { useSubjectAssessmentSavedFilterStore } from 'stores/subjectAssessmentSavedFilter'
import useSatuEventAssessment from '../utils/useSatuEventAssessment'
import { EVENT_NAME_ASSESSMENT_SUBJECT_VIEW_HOME_V2 } from '../data'

import type { TFase, TFaseGroup } from 'types/classAndPhases'

const SearchApp = () => {
  const { SETrackEventAssessment } = useSatuEventAssessment()
  const {
    setPhase: setStorePhase,
    setSubject: setStoreSubject,
    setPhaseGroup: setStorePhaseGroup,
    subjectAssessmentSavedFilters,
  } = useSubjectAssessmentSavedFilterStore(
    ({
      setPhase,
      setSubject,
      setPhaseGroup,
      subjectAssessmentSavedFilters,
    }) => ({
      setPhase,
      setSubject,
      setPhaseGroup,
      subjectAssessmentSavedFilters,
    }),
    shallow
  )
  const [isFaseSheetOpen, setIsFaseSheetOpen] = React.useState<boolean>(false)
  const [isMapelSheetOpen, setIsMapelSheetOpen] = React.useState<boolean>(false)
  const [selectedFaseGroup, setSelectedFaseGroup] =
    React.useState<TFaseGroup>(null)
  const [selectedFase, setSelectedFase] = React.useState<TFase>(null)
  const [selectedMapel, setSelectedMapel] = React.useState<string>('')

  const router = useRouter()

  React.useEffect(() => {
    const {
      phase: storePhase,
      subject: storeSubject,
      phaseGroup: storePhaseGroup,
    } = subjectAssessmentSavedFilters
    if (storePhase) setSelectedFase(storePhase)
    if (storeSubject) setSelectedMapel(storeSubject)
    if (storePhaseGroup) setSelectedFaseGroup(storePhaseGroup)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (selectedFase === 'Fondasi') {
      setSelectedMapel('PAUD')
    } else {
      setSelectedMapel('')
    }
  }, [selectedFase])

  React.useEffect(() => {
    SETrackEventAssessment({
      eventName: EVENT_NAME_ASSESSMENT_SUBJECT_VIEW_HOME_V2,
      sendAttributes: false,
      sendUserAgent: true,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <HeaderBar variant="transparent" borderless>
        <HeaderBarLeftAction
          onClick={() => historyUtils?.backToApp(router?.back)}
        />
        <HeaderBarTitle className="ml-4">Asesmen Pembelajaran</HeaderBarTitle>
      </HeaderBar>

      <SearchSection
        selectedFaseGroup={selectedFaseGroup}
        selectedFase={selectedFase}
        selectedMapel={selectedMapel}
        setIsFaseSheetOpen={setIsFaseSheetOpen}
        setIsMapelSheetOpen={setIsMapelSheetOpen}
      />

      <FaseSheet
        close={() => setIsFaseSheetOpen(false)}
        isOpen={isFaseSheetOpen}
        selectedFase={selectedFase}
        setSelectedFase={(value) => {
          setSelectedFase(value)
          setStorePhase(value)
        }}
        selectedFaseGroup={selectedFaseGroup}
        setSelectedFaseGroup={(value) => {
          setSelectedFaseGroup(value)
          setStorePhaseGroup(value)
        }}
      />

      <MapelSheet
        close={() => setIsMapelSheetOpen(false)}
        isOpen={isMapelSheetOpen}
        selectedFaseGroup={selectedFaseGroup}
        selectedFase={selectedFase}
        selectedSubject={selectedMapel}
        setSelectedSubject={(value) => {
          setSelectedMapel(value)
          setStoreSubject(value)
        }}
      />
    </>
  )
}

export default SearchApp
